import { render, staticRenderFns } from "./ConstructionTab.vue?vue&type=template&id=60911fcb&scoped=true"
import script from "./ConstructionTab.vue?vue&type=script&lang=js"
export * from "./ConstructionTab.vue?vue&type=script&lang=js"
import style0 from "./ConstructionTab.vue?vue&type=style&index=0&id=60911fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60911fcb",
  null
  
)

export default component.exports